<template>
  <Modal :setModalStyle="setModalStyle">
    <div slot="header" class="modal_header">
      <div class="modal_imgWrap" v-if="modalImg !== ''">
        <img :src="require(`@/assets/images/${modalImg}`)" />
      </div>
      <div class="modal_closeBtn" v-if="closeType === 'close'">
        <img src="@/assets/images/x_popup.svg" @click.prevent="SET_POPUP(false)" />
      </div>
      <div class="modal_closeBtn" v-if="closeType === 'action'">
        <img src="@/assets/images/x_popup.svg" @click.prevent="closeAction()" />
      </div>
      <div class="modal_closeBtn" v-if="closeType === 'mobileAction'">
        <img src="@/assets/images/x_popup.svg" @click.prevent="mobileAction()" />
      </div>
      <div class="modal_closeBtn" v-if="closeType === 'mobileDeleteAuth'">
        <img src="@/assets/images/x_popup.svg" @click.prevent="mobileDeleteAuth()" />
      </div>
    </div>
    <div slot="body">
      <p v-html="modalBody"></p>
    </div>
    <div slot="footer" v-if="count === 'single'">
      <div class="modal_btnWrap single">
        <button
          class="btn confirm"
          :type="btnType"
          @click.prevent="SET_POPUP(false)"
          v-text="confirmBtnText"
        ></button>
      </div>
    </div>
    <div slot="footer" v-if="count === 'double'">
      <div class="modal_btnWrap double">
        <button class="btn cancel" @click.prevent="SET_POPUP(false)" v-text="cancelBtnText">취소</button>
        <button
          class="btn confirm"
          :type="btnType"
          v-text="confirmBtnText"
          @click.prevent="btnMove()"
        ></button>
      </div>
    </div>
    <div slot="footer" v-if="count === 'triple'">
      <div class="modal_btnWrap triple">
        <button class="btn cancel" v-text="cancelBtnText" onclick="location.href='/login'">로그인</button>
        <button
          class="btn confirm"
          :type="btnType"
          v-text="confirmBtnText"
          onclick="location.href='/ChoiceType'"
        >전화예약상담</button>
      </div>
      <div class="modal_outSide">
        <div class="mo_imgWrap">
          <img src="@/assets/images/call.svg" />
        </div>
        <button
          class="btn"
          :type="btnType"
          v-text="anotherBtnText"
          @click.prevent="btnMoveClosed()"
        ></button>
      </div>
    </div>
    <div slot="footer" v-if="count === 'another'">
      <div class="modal_btnWrap single">
        <button
          class="btn confirm"
          :type="btnType"
          @click.prevent="btnMoveClosed()"
          v-text="confirmBtnText"
        ></button>
      </div>
    </div>

    <div slot="footer" v-if="count === 'causeAction'">
      <div class="modalInput" v-if="onInput">
        <span v-if="!inputError">*내용을 입력해주세요.</span>
        <textarea type="text" v-model="checkInput" id="onInput" ref="checkInput" />
      </div>
      <div class="modal_btnWrap single">
        <button
          class="btn confirm"
          :type="btnType"
          :disabled="!inputError"
          @click.prevent="causeAction()"
          v-text="confirmBtnText"
        ></button>
      </div>
    </div>
    <div slot="footer" v-if="count === 'causeActionNormal'">
      <div class="modal_btnWrap single">
        <button
          class="btn confirm"
          :type="btnType"
          @click.prevent="causeAction()"
          v-text="confirmBtnText"
        ></button>
      </div>
    </div>

    <div slot="footer" v-if="count === 'causeActionCancelBtn'">
      <div class="modal_btnWrap double">
        <button
          class="btn cancel"
          :type="btnType"
          v-text="cancelBtnText"
          @click.prevent="SET_POPUP(false)"
        ></button>
        <button
          class="btn confirm"
          :type="btnType"
          @click.prevent="causeAction()"
          v-text="confirmBtnText"
        ></button>
      </div>
    </div>

    <div slot="footer" v-if="count === 'causeActionDouble'">
      <div class="modal_btnWrap double">
        <button
          class="btn cancel"
          :type="btnType"
          v-text="cancelBtnText"
          @click.prevent="prevUrl()"
        ></button>
        <button
          class="btn confirm"
          :type="btnType"
          @click.prevent="causeAction()"
          v-text="confirmBtnText"
        ></button>
      </div>
    </div>

    <div slot="footer" v-if="count === 'actionBtn'">
      <div class="modal_btnWrap double">
        <button
          class="btn cancel"
          :type="btnType"
          v-text="cancelBtnText"
          @click.prevent="prevUrl()"
        ></button>
        <button
          class="btn confirm"
          :type="btnType"
          v-text="confirmBtnText"
          @click.prevent="btnClose()"
        ></button>
      </div>
    </div>

    <div slot="footer" v-if="count === 'actionDouble'">
      <div class="modal_btnWrap double">
        <button
          class="btn cancel"
          :type="btnType"
          v-text="cancelBtnText"
          @click.prevent="prevUrl()"
        ></button>
        <button
          class="btn confirm"
          :type="btnType"
          v-text="confirmBtnText"
          @click.prevent="causeAction()"
        ></button>
      </div>
    </div>

    <div slot="footer" v-if="count === 'mobileAction'">
      <div class="modal_btnWrap single">
        <button
          class="btn confirm"
          :type="btnType"
          @click.prevent="mobileAction()"
          v-text="confirmBtnText"
        ></button>
      </div>
    </div>
    <div slot="footer" v-if="count === 'mobileDeleteAuth'">
      <div class="modal_btnWrap single">
        <button
          class="btn confirm"
          :type="btnType"
          @click.prevent="mobileDeleteAuth()"
          v-text="confirmBtnText"
        ></button>
      </div>
    </div>
  </Modal>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import Modal from './Modal.vue'
import { getCookie } from '../utils/cookieNew'

export default {
  props: {
    popupSet: {
      title: '',
      modalImg: {
        type: String
      },
      content: {
        type: String
      },
      confirmBtnText: {
        type: String
      },
      cancelBtnText: {
        type: String
      },
      anotherBtnText: {
        type: String
      },
      btnType: {
        type: String
      },
      count: {
        type: String,
        default: 'double'
      },
      nextLink: {
        type: String
      },
      closeType: {
        type: String,
        default: 'close'
      },
      closeLink: {
        type: String,
        default: '/'
      },
      prevLink: {
        type: String
      },
      nextLink_another: {
        type: String
      },
      causeAction: {
        type: String
      },
      bigModal: {
        default: false
      },
      longHeight: {
        default: false
      },
      specialPick: {
        default: false
      },
      topImg: {
        default: false
      },
      onInput: {
        default: false
      },
      mobileLink: {
        type: String
      },
      currentURL: {
        type: String
      }
    }
  },
  components: {
    Modal
  },
  data () {
    return {
      input: '',
      valid: false,
      onInput: this.popupSet.onInput,
      modalImg: this.popupSet.modalImg,
      modalBody: this.popupSet.content,
      confirmBtnText: this.popupSet.confirmBtnText,
      cancelBtnText: this.popupSet.cancelBtnText,
      anotherBtnText: this.popupSet.anotherBtnText,
      btnType: this.popupSet.btnType,
      count: this.popupSet.count,
      nextLink: this.popupSet.nextLink,
      nextLink_another: this.popupSet.nextLink_another,
      closeType: this.popupSet.closeType,
      closeLink: this.popupSet.closeLink,
      setModalStyle: {
        bigModal: this.popupSet.bigModal,
        specialPick: this.popupSet.specialPick,
        longHeight: this.popupSet.longHeight,
        topImg: this.popupSet.topImg,
        url: ''
      },
      currentURL: this.popupSet.currentURL,
      checkInput: '',
      inputError: false,
      mobileLink: this.popupSet.mobileLink
    }
  },
  watch: {
    checkInput (val) {
      this.inputError = !!val.trim().length
    }
  },
  mounted () {},
  computed: {
    ...mapState(['checkPopup'])
  },
  methods: {
    ...mapMutations(['SET_POPUP']),
    mobileDeleteAuth () {
      console.log('권한에러 액션버튼 진입')
      this.SET_POPUP(false)
      if (sessionStorage.getItem('userAgent') === 'mobile') {
        const url = 'thanq://logout'
        document.location.href = url
      }
      if (getCookie('token') === undefined) {
        this.$router.push(this.mobileLink)
        sessionStorage.removeItem('authErrorCause')
      } else {
        sessionStorage.setItem('authErrorCause', 'mutated')
        window.location.reload()
      }
    },
    mobileAction () {
      location.href = this.mobileLink
    },
    addPopup () {
      this.SET_POPUP(false)
    },
    btnMove () {
      this.$router.push(this.nextLink)
    },
    btnMove_another () {},
    btnMoveClosed () {
      this.$router.push(this.nextLink)
      this.SET_POPUP(false)
    },
    causeAction () {
      this.SET_POPUP(false)
      this.$emit('causeAction')
    },
    prevUrl () {
      this.$router.go(-1)
      this.SET_POPUP(false)
    },
    btnClose () {
      this.SET_POPUP(false)
    },
    closeAction () {
      this.$router.push(this.closeLink)
      this.SET_POPUP(false)
    },
    prevAction () {
      // if (this.checkPopup(true)) {
      //   console.log('this.checkPopup: ', this.checkPopup)
      //   window.history.pushState(null, '', location.href)
      //   window.onpopstate = () => {
      //     history.go(1)
      //     this.SET_POPUP(false)
      //   }
      // } else if (this.checkPopup(false)) {
      //   console.log('this.checkPopup:: ', this.checkPopup)
      //   window.onpopstate = () => {
      //     history.go(-1)
      //   }
      // }
    }
  },
  created () {
    this.prevAction()
  }
}
</script>

<style lang="scss" scoped>
</style>
